module.exports = __webpack_public_path__ + "img/one-green-fire.49977c61.svg";